module.exports = __webpack_public_path__ + "img/notify.e1b97ed1.svg";